import React from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => {
	return {
		formatHint: {
			width: '100%',
			margin: 0,
			color: theme.palette.text.secondary,
		},
	};
});

const BinGroupsHint = () => {
	const translate = useTranslate();
	const classes = useStyles();
	return (
		<p className={classes.formatHint} dangerouslySetInnerHTML={{ __html: translate('resources.binGroups.labels.formatHint') }} />
	);
};

export default BinGroupsHint;
